import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  Grid,
  IconButton,
  Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { useParams } from 'react-router-dom';

import {
  getGantIssueCreateTrackers,
  getGanttAddBasePlan,
  saveConfirmationReinit,
  saveGanttBasePlan,
} from '../../../../../packages/common/api';
import FormField from '../../../../../packages/common/shared-ui/src/components/FormField/FormField';
import ClearIcon from '../../../../../packages/common/shared-ui/src/icons/ClearIcon';
import { useTranslation } from '../../../../../packages/common/utils/getLocalString';

// Original class: modalRoot
const StyledModalRoot = styled(Dialog)(theme => ({
  '& .MuiPaper-root.MuiDialog-paper': {
    overflow: 'visible',
    padding: '24px 20px 20px 20px',
    maxWidth: '600px',
    backgroundColor: '#F1F2F8',
    borderRadius: '16px',
    maxHeight: 'calc(100% - 130px)',
    margin: 0,
  },
}));

const GanttAddBasePlanModal = ({ open, handleClose, handleSave }) => {
  const getLocalString = useTranslation();
  const pageParams = useParams();
  const navigate = useNavigate();
  const [basePlanField, setBasePlanField] = useState(null);
  const [loading, setLoading] = useState(true);

  const handleError = useCallback(
    error => {
      if (error) {
        navigate(`/errors/error-${error.status}`);
      }
    },
    [navigate],
  );

  useEffect(() => {
    let ignore = false;
    //setLoading(true);
    async function getAddBasePlan() {
      const { data: res } = await getGanttAddBasePlan(pageParams.projectId);
      if (!ignore) {
        return res;
      }
    }
    if (pageParams.projectId && open) {
      getAddBasePlan()
        .then(res => {
          setBasePlanField({
            fieldId: 'basePlan',
            fieldName: getLocalString(
              'GanttContainer',
              'labels',
              'basePlanField',
            ),
            valueId: null,
            valueName: null,
            fieldDefinition: {
              fieldId: 'basePlan',
              fieldName: getLocalString(
                'GanttContainer',
                'labels',
                'basePlanField',
              ),
              fieldFormat: 'list',
              isMultiple: false,
              values: res,
            },
          });
          setLoading(false);
        })
        .catch(error => handleError(error.response));
      return () => {
        ignore = true;
      };
    }
  }, [handleError, pageParams.projectId, open]);

  const handleFormField = useCallback(data => {
    setBasePlanField(prev => ({
      ...prev,
      valueName: data.valueId,
      valueId: data.valueId,
    }));
  }, []);

  const handleSaveButton = useCallback(async () => {
    try {
      const response = await saveGanttBasePlan(
        pageParams.projectId,
        Number(basePlanField.valueId.valueId),
      );
      if (response) {
        handleSave();
        //handleClose();
      }
    } catch (error) {
      handleError(error.response);
    }
  }, [basePlanField, handleClose, handleError, pageParams.projectId]);

  const handleCloseButton = useCallback(() => {
    handleClose();
  }, [handleClose]);

  return (
    <StyledModalRoot open={open} disableRestoreFocus fullWidth>
      <Grid
        container
        wrap='nowrap'
        sx={{
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '20px',
        }}
      >
        <Typography
          variant='h1'
          sx={{
            color: '#082253',
          }}
        >
          {getLocalString('GanttContainer', 'labels', 'addBasePlan')}
        </Typography>
        <IconButton disableRipple value='close' onClick={handleCloseButton}>
          <Box
            sx={{
              width: 24,
              height: 24,
            }}
          >
            <ClearIcon width={24} height={24} viewBox='0 0 24 24' />
          </Box>
        </IconButton>
      </Grid>
      {loading && (
        <Grid
          container
          sx={{
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            height: '100%',
            zIndex: 99,
            position: 'absolute',
            left: 0,
            top: 0,
          }}
        >
          <CircularProgress color='secondary' />
        </Grid>
      )}
      {basePlanField && (
        <Box>
          <FormField
            field={basePlanField}
            fieldEvent={handleFormField}
            fullWidth={true}
            borderless={true}
          ></FormField>
        </Box>
      )}
      <Grid
        container
        sx={{
          justifyContent: 'center',
          marginTop: 5,
        }}
      >
        <Button
          disableRipple
          variant='cutGreyPrimaryBig'
          onClick={handleCloseButton}
        >
          <Typography
            variant='h5'
            sx={{
              fontWeight: 700,
            }}
          >
            {getLocalString('buttons', 'cancel')}
          </Typography>
        </Button>
        <Box
          sx={{
            marginLeft: 1,
          }}
        >
          <Button
            disableRipple
            variant='cutBlueSecondary'
            onClick={handleSaveButton}
            //disabled={ganttIssueFields.length === 0 || getFieldsLoading || formError.date}
          >
            <Typography
              variant='h5'
              sx={{
                fontWeight: 700,
              }}
            >
              {getLocalString('buttons', 'save')}
            </Typography>
          </Button>
        </Box>
      </Grid>
    </StyledModalRoot>
  );
};

export default GanttAddBasePlanModal;
